import React, { Component } from 'react'
import PropTypes from 'prop-types'

class MultipleForm extends Component {
  static propTypes = {
    openIndices: PropTypes.arrayOf(PropTypes.number),
    onStateChange: PropTypes.func,
    stateReducer: PropTypes.func,
    children: PropTypes.func,
  }

  static defaultProps = {
    stateReducer: (state, changes) => changes,
    onStateChange: () => {},
  }

  constructor(props) {
    super(props)
    this.state = {
      openIndices: this.props.openIndices || [0],
    }
  }

  setInternalState = changes => {
    let finalChanges
    this.setState(
      state => {
        const currentState = this.state
        const upcomingChanges = changes(currentState)
        finalChanges = this.props.stateReducer(currentState, upcomingChanges)
        return finalChanges
      },
      () => {
        this.props.onStateChange(finalChanges)
      }
    )
  }

  handleItemClick = index => {
    this.setInternalState(state => {
      const isClosing = state.openIndices.includes(index)
      return {
        type: isClosing ? 'closing' : 'opening',
        openIndices: isClosing
          ? state.openIndices.filter(i => i !== index)
          : [...state.openIndices, index],
      }
    })
  }

  render() {
    const { children } = this.props
    const { openIndices } = this.state
    return (
      <div>
        {children({
          openIndices,
          handleItemClick: this.handleItemClick,
        })}
      </div>
    )
  }
}

export default MultipleForm
